
import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
import { Util } from "app/models/util";
import { LpmCopilotConfig } from "app/models/lpm.config";
import { Agent, Assistant, DataStructure } from "app/models/copilot.model";

@Injectable({
  providedIn: "root",
})
export class RagService extends DMSBaseService {
  constructor(public provider: ServiceProvider,
    public util: Util
    ) {
    super("/rag", provider);
  }

  getAllSessions(){
    return this.getList(`/session`); // Assuming this returns a list of sessions
  }

  askInSession( sessionId: string , payload:{content:string} ,isAgent ) {
    if(isAgent){
      return this.save(payload, `/agent/session/${sessionId}/ask`,true);
    }
    return this.save(payload, `/session/${sessionId}/ask`,true);
  }

  createSession(payload){
    return this.save(payload, `/session`);
  }

  getSessionMessages(sessionId: string){
    return this.getRecord(`/session/${sessionId}/messages`);
  }

  postSessionEmbeddings(fileIds: string[], sessionId: string){
    return this.save(fileIds, `/session/${sessionId}/embeddings/assets`);
  }

  getMessagesbyAssetIdAndSessionId(assetId: string,sessionId:string) {
   
    return this.getRecord(`/asset/${assetId}/session/${sessionId}/messages`);
  }

  askByAssetId(assetId: string,sessionId:string, payload:{content:string}) {
    return this.save(payload, `/asset/${assetId}/session/${sessionId}/ask`,true);
  }

  getAllSessionsByAssetId(assetId:string){
    return this.getList(`/asset/${assetId}/sessions`); // Assuming this returns a list of sessions
  }

  createAssetSession(assetId:string, chatAssistantId:string=null, payload?: LpmCopilotConfig, isAgent = false){
    const queryParams = this.util.getQueryMethod({
      matterId: payload?.matterId,
      contactId: payload?.contactIds.join(','),
      chatAssistantId:chatAssistantId
    })
    if(isAgent){
      return this.save(null, `/asset/${assetId}/agent/session${queryParams}`);
    }
    return this.save(null, `/asset/${assetId}/sessions${queryParams}`);
  }

  deleteSession(sessionId: string){
    return this.deleteRecord(`session/${sessionId}`);
  }

  getSettings(){
    return this.getRecord(`/settings`);
  }

  getSettingsByAccountId(id:string){
    return this.getRecord(`/settings/account/${id}`);
  }

   getAssistants(){
    return this.getRecord(`/assistant`);
  }

   saveAssistant(data : Assistant){
    if(data.id) return this.update(data, '/assistant')
    else return this.save(data ,'/assistant')
   }

    deleteAssistant(id){
     return this.deleteRecord(`/assistant/${id}`)
   }

    getAgents(){
    return this.getRecord(`/agent`);
  }

   saveAgent(data : Agent){
    if(data.id) return this.update(data, '/agent')
    else return this.save(data ,'/agent')
   }

    deleteAgent(id){
     return this.deleteRecord(`/agent/${id}`)
   }

    getDataStructure(){
    return this.getRecord(`/data-structure`);
  }

   saveDataStructure(data : DataStructure){
    if(data.id) return this.update(data, '/data-structure')
    else return this.save(data ,'/data-structure')
   }

    deleteDataStructure(id){
     return this.deleteRecord(`/data-structure/${id}`)
   }

  // onboarding and update settings
  saveSettings(payload){
    return this.save(payload, `/onboard`);
  }

  offBoardCopilot(accountId:string){
    return this.getRecord(`/offboard/account/${accountId}`);
  }

  searchAssetSessions(assetId:string, searchText:string){
    const queryParams = this.util.getQueryMethod({keywords:searchText})
    return this.getList(`/asset/${assetId}/search${queryParams}`);
  } 

  getAssetDetails(assetId:string){
    return this.getRecord(`/asset/${assetId}`);
  }

  exportData(sessionId:string,data){
    return this.save(data, `/agent/session/${sessionId}/export`);
  }

  getAssetScopedAssets(assetId:string){
    return this.getList(`/asset/${assetId}/scope`);
  }

}
